import React from 'react';
import { IconTextButton, Statistic } from 'ui-lib';
import deviceCss from './device-attributes.css';
import cx from 'classnames';
import { useInteractiveAttribute } from './use-interactive-attribute';
import { ITextFieldValidation, TextAttributeItem } from './text-attribute-item';
import { DeviceInfosStore } from 'store/device-details/device-info-store';
import { DeviceAttributeName } from 'dto/device-dto';
import { observer } from 'mobx-react';

interface IInteractiveStatistic {
    deviceInfosStore: DeviceInfosStore;
    title: string;
    attributeName: DeviceAttributeName;
    initialValue: string;
    form?: any;
    className?: string;
}

export const InteractiveStatisticTextFieldItem = observer((props: IInteractiveStatistic) => {
    const { attributeName, title, initialValue, deviceInfosStore, form, className } = props;
    const [textFieldValidation, setTextFieldValidation] = React.useState<ITextFieldValidation>({
        status: 'success',
    });

    const { editing, hasPermission, attributeValue, toggleEdit, onSaveAttribute, onUpdateAttribute } = useInteractiveAttribute({
        attributeName,
        deviceInfosStore,
        initialAttributeValue: initialValue,
        onDestroy: () => {
            form?.resetFields([attributeName]);
            setTextFieldValidation({ status: 'success' });
        }
    });

    return (
        <Statistic
            className={cx(className, deviceCss['edit-detail-statistic'])}
            title={
                <div style={{ display: 'flex' }}>
                    <div className={deviceCss['edit-statistic-title']}>{title}</div>
                    <IconTextButton
                        key={`${attributeName}-action`}
                        className={deviceCss.editBtn}
                        onClick={toggleEdit}
                        hidden={!hasPermission}
                        iconName='edit'
                    />
                </div>
            }
            value={attributeValue}
            formatter={(value: string) => {
                if (editing) {
                    return (
                        <TextAttributeItem
                            attributeName={attributeName}
                            attributeValue={attributeValue}
                            textFieldValidation={textFieldValidation}
                            onChange={(values): void => {
                                setTextFieldValidation({ status: 'success' });
                                onUpdateAttribute(values.target.value);
                            }}
                            onSaveAttribute={onSaveAttribute}
                        />
                    );
                }
                return value || ' ';
            }}
        />
    );
});
